
import React from "react";
import { Trial } from "@/types/trials";
import TrialsLoading from "./TrialsLoading";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@/components/ui/table";
import { AlertTriangle } from "lucide-react";

interface TrialsListProps {
  trials: Trial[];
  isLoading: boolean;
}

const TrialsList: React.FC<TrialsListProps> = ({ trials, isLoading }) => {
  if (isLoading) {
    return <TrialsLoading />;
  }

  return (
    <div className="border rounded-md p-6 text-center">
      <div className="flex flex-col items-center justify-center py-8">
        <AlertTriangle className="h-12 w-12 text-amber-500 mb-4" />
        <h2 className="text-xl font-semibold mb-2">Funcionalidade temporariamente desativada</h2>
        <p className="text-gray-500 max-w-md">
          O módulo de test drives está desativado temporariamente até que a integração com o Supabase seja configurada.
        </p>
      </div>
    </div>
  );
};

export default TrialsList;
